import React, { useEffect } from 'react'
import { useAppSelector } from '../../redux/hook';
import { useGetOngoingApplicationQuery } from '../../redux/services/getOngoingApplicationsStatus';
import { LottieLoader } from '../../components/loader';

function PendingItemsPage() {
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);
  
  const { data: ongoingApplications, isLoading } = useGetOngoingApplicationQuery({uinfin:loginUser?.uinfin ?? "", singpass_token: singpassToken ?? ""});

  useEffect(()=>{
    console.log("ongoingApplications",ongoingApplications);
  },[ongoingApplications])
  
  if(isLoading){
    return <>
      <LottieLoader/>
    </>
  }
  
  if(ongoingApplications?.length === 0){
    return <>
      No results
    </>
  }

  return (
    <div></div>
  )
}

export default PendingItemsPage